import { collapsedContainerClass, collapsedLinkClass, expandedLinkClass } from './constants';
import { writeExpansionStatusToStorage } from './write-expansion-status-to-storage';

export const expandImageTiles = (showMoreColorsLink: HTMLElement, imageTileContainer: HTMLElement, productId: string) => {
    showMoreColorsLink.classList.remove(collapsedLinkClass);
    showMoreColorsLink.classList.add(expandedLinkClass);
    imageTileContainer.classList.remove(collapsedContainerClass);
    writeExpansionStatusToStorage(productId, true);
};
